import React from "react";
import {BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, LabelList} from "recharts";

const BigFiveChart = ({ bigFiveScores }) => {
    if (!bigFiveScores || bigFiveScores.length === 0) return <p className="text-white text-center">No data available.</p>;

    // ✅ Updated Colors (Avoids Theme Overlap)
    const colors = {
        "Conscientiousness": "#ff66e6",  // Pink
        "Extroversion": "#008000",       // Green
        "Emotional Stability": "#4444CC", // Purple
        "Agreeableness": "#FFD700",      // Yellow
        "Intellect": "#32CEE5",          // Sky Blue
    };

    // 📌 Sort Big Five scores from highest to lowest
    const sortedBigFive = [...bigFiveScores].sort((a, b) => b.score - a.score);

    return (
        <div className="w-full h-full">
            <ResponsiveContainer width="100%" height={400}>
                <BarChart
                    layout="vertical"
                    data={sortedBigFive}
                    margin={{ top: 10, right: 30, left: 20, bottom: 10 }}
                >
                    <XAxis type="number" domain={[0, 100]} tick={{ fill: "#ffffff" }} />
                    <YAxis type="category" dataKey="subscale" tick={{ fill: "#ffffff" }} width={130} /> {/* Reduced axis width */}
                    <Bar dataKey="score">
                        {sortedBigFive.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={colors[entry.subscale] || "#999"} />
                        ))}
                        <LabelList dataKey="score" position="right" fill="white" fontSize={14} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default BigFiveChart;
